const hasWindow = typeof window == 'object';

export function isClient() {
  return hasWindow;
}



/** WEBPACK FOOTER **
 ** ./client/app/shared/utils/client.util.ts
 **/